<template lang="pug">
Modal.PrivacySets(ref="modal")
  form.__body(@submit.prevent="_handleSubmit({ values })")
    //- h1 {{ L['privacy.modal.h1'] }}

    Checkbox(name="necessary",
        label="Necessary cookies", :set="true", v-model:value.input="values.necessary", disabled)
      p(v-html="L['privacy.modal.necessary']")

    Checkbox(name="analytical",
        label="Analytical cookies", :set="true", v-model:value.input="values.analytical")
      p(v-html="L['privacy.modal.analytical']")

    Checkbox(name="marketing",
        label="Marketing cookies", :set="true", v-model:value.input="values.marketing")
      p(v-html="L['privacy.modal.marketing']")

    .d-flex.--spread.__footer
      router-link.Btn.--a(:to="ROUTES.PRIVACY", target="_blank") {{ L['privacy.modal.to_policy'] }}
      Btn(kind="act", type="submit")
        | {{ state.submitted ? L['privacy.modal.submit.done'] : L['privacy.modal.submit.save'] }}

</template>
<script>
import Checkbox from 'components/UI/Checkbox';
import Btn from 'components/UI/Btn';
import content from 'content';

import Modal from 'components/Modal';
import { TEST } from 'const';

export default {
  name: 'PrivacySets',
  emits: ['save'],

  data () {
    return {
      state: {
        submitted: false,
      },
      values: {
        ...this.sets,
        necessary: true,
      },
    };
  },

  static: () => ({ L: content }),

  methods: {
    toggle () {
      this.$refs.modal.toggle();
    },

    async _handleSubmit ({ values }) {
      console.log(values);
      this.$emit('save', values);
      this.state.submitted = true;
      await new Promise(r => setTimeout(r, TEST ? 0 : 300));
      this.toggle(false);
    },
  },

  props: {
    sets: {
      type: Object,
      default: () => ({
        analytical: true,
        marketing: true,
      }),
    },
  },

  components: {
    Checkbox,
    Modal,
    Btn,
  },
};

</script>
<style>
.PrivacySets {
  --c: #203254;

  color: var(--white);

  .__body {
    /*display: flex;
    flex-direction: column;
    gap: 22px;*/


    background: #3D5484;
  }

  .__footer .FormSubmit {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 148px;
    height: 54px;
    padding: 14px 27px 16px;

    font-size: 18px;
    font-weight: normal;
    letter-spacing: -1px;

    border-radius: 27px;
  }

  .Checkbox {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 22px;

    padding-bottom: 16px;

    &:not(:nth-child(3)) { border-bottom: 1px solid #2C3E64; }

    &__label {
      order: -1;
/*      margin-bottom: 24px;*/
      margin-left: 0;

      font-weight: 700;
      font-size: 20px;
      line-height: 20px;
    }

    p {
      font-weight: 400;
      font-size: 14px;
      line-height: 148.41%;
      /* or 21px */

      letter-spacing: -0.065em;
    }
  }

  h1 { margin-bottom: 28px }

  .Btn.--act {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 148px;
    height: 40px;

    color: var(--c);

    background-color: var(--white);
    border: 1px solid var(--white);
    border-radius: 0;
    box-shadow: none !important;
  }

  .Btn.--a {
    color: var(--white);
    text-decoration: underline;
  }
}

@media (min-width: 740px) {
  .PrivacySets {
    .__body {
      padding: 40px;
    }

    .Checkbox {
      height: 130px;
    }
  }
}

@media (max-width: 739px) {
  .PrivacySets {
    --z-index: calc(var(--zi-privacy-contest) + 1);

    .Modal__wrapper { padding: 0 }
    .Modal__container {
/*      min-height: 100vh;*/
      padding-top: calc(var(--header-h) + 40px);
      padding-bottom: calc(var(--botbar-h) + 40px);
    }

    .__body {
      display: flex;
      flex-direction: column;
      padding: 40px 16px;
    }

    .Checkbox__label { margin-bottom: 22px }
  }
}
</style>
